import RightArrow from "../../elements/RightArrow";
import React from "react";
// react library for routing
import { Link } from "react-router-dom";
// reactstrap components
import {
  UncontrolledCollapse,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  Button,
} from "reactstrap";

import gcWordmark from "assets/img/growthcloud/growthcloud_wordmark.svg";

class AdminNavbar extends React.Component {
  render() {
    return (
      <>
        <Navbar
          className={`navbar-horizontal navbar-main navbar-light ${
            this.props.bg ? "bg-" + this.props.bg : ""
          }`}
          expand="lg"
          id="navbar-main"
        >
          <Container>
            <div className="navbar-brand">
              <a href="https://growthcloud.com">
                <img alt="..." src={this.props.logo || gcWordmark} />
              </a>
            </div>

            <UncontrolledCollapse
              className="navbar-custom-collapse"
              navbar
              toggler="#navbar-collapse"
            >
              <div className="navbar-collapse-header">
                <Row>
                  <Col className="collapse-brand" xs="6"></Col>
                  <Col className="collapse-close" xs="6">
                    <button
                      aria-controls="navbar-collapse"
                      aria-expanded={false}
                      aria-label="Toggle navigation"
                      className="navbar-toggler"
                      data-target="#navbar-collapse"
                      data-toggle="collapse"
                      id="navbar-collapse"
                      type="button"
                    >
                      <span />
                      <span />
                    </button>
                  </Col>
                </Row>
              </div>
              <Nav className="ml-auto mr-auto" navbar></Nav>
              <hr className="d-lg-none" />
              <Nav className="align-items-lg-center ml-lg-auto" navbar>
                <NavItem className="d-none d-lg-block ml-lg-4">
                  <NavLink to="/login" tag={Link}>
                    <span className="nav-link-inner--text">Login</span>
                  </NavLink>
                </NavItem>
                <NavItem className="d-none d-lg-block ml-lg-1">
                  <Link to="/register">
                    <Button color="primary">
                      <span className="nav-link-inner--text">
                        Get Started <RightArrow></RightArrow>
                      </span>
                    </Button>
                  </Link>
                </NavItem>
              </Nav>
            </UncontrolledCollapse>
          </Container>
        </Navbar>
      </>
    );
  }
}

export default AdminNavbar;
